
import ok from '@/ok-utils/ok.js'
import {MessageBox, Message, Loading} from 'element-ui'

export default {

  userAgentAndroid() {
    //#ifndef MP-WEIXIN
    var u = navigator.userAgent;
    if (u.toLowerCase().indexOf("android") > -1)
      return true;
    else
      return false;
    //#endif
    return false;
  },

  userAgentIos() {
    //#ifndef MP-WEIXIN
    var u = navigator.userAgent.toLowerCase();
    if (u.indexOf("iphone") > -1 || u.indexOf("ipad") > -1 || u.indexOf("ipod") > -1)
      return true;
    else
      return false;
    //#endif
    return false;
  },
  userAgentWeixin() {
    //#ifndef MP-WEIXIN
    var u = navigator.userAgent;
    if (u.toLowerCase().indexOf("micromessenger") > -1)
      return true;
    else
      return false;
    //#endif
    return false;
  },
  phoneFormat(phone) {
    if (String(phone).length != 11) return phone;
    var mobile = String(phone);
    var reg = /^(\d{3})\d{4}(\d{4})$/;
    return mobile.replace(reg, '$1****$2');
  },
  arrayFindIndex(arr, item) {
    for (var i = 0; i !== arr.length; ++i) {
      if (arr[i] == item) {
        return i;
      }
    }
    return -1;
  },
  arrayFindIndexValue(arr,attribute, value) {
    for (var i = 0; i !== arr.length; ++i) {
      if (arr[i][attribute] == value) {
        return i;
      }
    }
    return -1;
  },
  message: {
    success(msg) {
      Message.success(msg)
    },
    error(msg) {
      Message.error(msg)
    },
    info(msg) {
      Message.info(msg)
    },
    warning(msg) {
      Message.warning(msg)
    },
  },

  uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  },

  text_format(tag, maxLenth) {
    if (tag == null) return null;
    if (tag == null) return null;
    if (tag.length > maxLenth)
      return tag.toString().substring(0, maxLenth) + "...";
    else
      return tag;
  },
  getPageData(path) {
    var pages = this.getUniPage();
    var name = path.replace(/\//g, "_");
    if (name.substring(0, 1) != '_') name = "_" + name;
    var data = pages[name];
    return data;
  },

  _timeId: 0,
  _timeFun: [],
  timeIntervalMain() {
    if (ok.tool._timeId == 0) {
      ok.tool._timeId = setInterval(() => {
        var _deltet = -1;
        for (var i = 0; i < ok.tool._timeFun.length; i++) {
          var item = ok.tool._timeFun[i];
          if (item.delete == 0) {
            // console.log(item.tag.$refs[item.ref]);
            if (item.tag.$refs[item.ref] == null)
              item.delete = 1;
            if (item.delete == 0) {
              if (item.tag.$refs[item.ref].length == 0)
                item.delete = 1;
            }
            // console.log(item.name);
            // console.log(window.location.toString());
            // if (item.delete == 0) {
            //   if (item.name != window.location.toString())
            //     item.delete = 1;
            // }
            if (item.delete == 0) {
              item.timeOut++;
              if (item.timeOut > item.time) {
                item.timeOut = 0;
                item.fun();
              }
            }
          } else
            _deltet = i;
        }
        if (_deltet >= 0) {
          ok.tool._timeFun.splice(_deltet, 1);
        }
        //console.log(ok.tool._timeFun.length);
      }, 100);
    }
  },
  timeIntervalAdd(tag, time, fun) {
   this.timeIntervalAddRefs(tag,"timeTag",time,fun);
  },
  timeIntervalAddRefs(tag,ref, time, fun) {
    if (tag.$refs[ref] != null) {
      var name = window.location.toString();
      ok.tool._timeFun.push({
        time: time,
        tag: tag,
        fun: fun,
        ref: ref,
        timeOut: 0,
        delete: 0,
        name: name,
      });
    }
  },


  obj_copy(obj, tag) {
    if (tag == null) return obj;
    if (obj == null) return obj;
    for (var key in obj) {
      if (tag[key] != null) {
        obj[key] = tag[key];
      }
    }
    return obj;
  },
}
